<app-card [heading]="heading()" class="single-item">
  <div actions name="tableActions">
    @if (!empty() && !loading()) {
      <app-dropdown placement="bottom-right">
        <button appDropdownButton [attr.aria-label]="actionsLabel" class="btn btn-transparent">
          <i class="icon fas fa-ellipsis-h"></i>
        </button>
        <button appDropdownItem name="downloadCSV" (click)="initiateDownload()">
          <i class="icon fas fa-arrow-down"></i>Export to CSV
        </button>
      </app-dropdown>
    }
  </div>

  <app-table
    appChartLoader
    [empty]="empty()"
    [loading]="loading()"
    [dataId]="dataId()"
    [columns]="columns()"
    [groups]="groups()"
    [data]="data()"
  />

  <ng-content />
</app-card>
